import './index.scss'
import '../../assets/scripts/jquery.nicescroll.min'

// 自定义滚动条插件
if (window.devicePixelRatio < 2) {
    if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
        $('body').niceScroll({
            mousescrollstep: 40,
            scrollspeed: 80,
            zindex: 101,
            cursorcolor: '#BDBDBD',
            cursorborder: '1px solid #BDBDBD',
            cursorwidth: '5px',
            cursoropacitymax: 0.6,
            smoothscroll: true,
            iframeautoresizeL: true,
        });
    }
}
function resizeNiceScroll() {
    if (window.devicePixelRatio < 2) {
        if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
            setTimeout(() => {
                $('body').getNiceScroll().resize()
            }, 500);
        }
    }
}

$(document).scroll(function () { 
    var scroH = $(document).scrollTop();  
    var viewH = $(window).height();        
    var contentH = $(document).height();       
    
    //底部文字滚动
    let about3Top = $('.about3').offset().top
    if (scroH > about3Top - viewH && $(window).width()> 990){
        let scrollNum = (scroH - about3Top + viewH) / 10

        let t1num = 100 - scrollNum > 42.7 ? 100 - scrollNum : 42.7
        let t2num = 100 - scrollNum > 45.57 ? 100 - scrollNum : 45.57

        $('.about3 .t1').css('right', t1num +'%')
        $('.about3 .t2').css('left', t2num + '%')
    }
});